function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.399 3.687l-4.643 4.322 4.485 4.793a1.885 1.885 0 0 1-.093 2.67 1.896 1.896 0 0 1-2.676-.093l-4.486-4.793-4.806 4.473a1.9 1.9 0 0 1-2.678-.091 1.886 1.886 0 0 1 .092-2.67l4.807-4.474-4.333-4.629A1.886 1.886 0 0 1 1.16.524a1.898 1.898 0 0 1 2.678.092l4.333 4.63L12.814.925a1.896 1.896 0 0 1 2.677.093 1.886 1.886 0 0 1-.092 2.669z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "#ff4f4f"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/reject-x.3cbd4abb.svg";
export { SvgComponent as ReactComponent };